import tokens from '@/PrimeVue/customDesignTokens';

export const filterAreaPt = {
  root: 'pv-filterarea',
  listContainer: 'pv-filterarea-list-container',
  option: options =>
    ({
      class:
        [
          'pv-filterarea-option',
          {
            'pv-filterarea-option-hover': options.context.focused,
            'pv-filterarea-option-selected': options.context.selected
          }
        ]
    })
};

export const filterAreaDt = {
  colorScheme: {
    light: {
      option: {
        padding: '0.5rem 10px 0',
        selected: {
          background: tokens.navigation.vertical.background.selected,
          color: '{listbox.option.color}',
          focus: {
            background: tokens.list.option.background.colors.hover,
            color: '{listbox.option.color}'
          }
        }
      },
      transitionDuration: tokens.primitive.durations.s0
    }
  }
};